import { render, staticRenderFns } from "./product-return-list.vue?vue&type=template&id=4d6a83c7&"
import script from "./product-return-list.vue?vue&type=script&lang=js&"
export * from "./product-return-list.vue?vue&type=script&lang=js&"
import style0 from "./product-return-list.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports